import List from "@/components/list";
import moment from "moment";
import { getItem } from "@/utils/storage";

const Table = args => {
  const { listeners, props } = args;
  const RCSelectionChange = listeners["selection-change"] || function () { };

  const deleteExamRule = listeners["deleteExamRule"] || function () { };
  const handleUpdate = listeners["handleUpdate"] || function () { };
  const detailsExamRule = listeners["detailsExamRule"] || function () { };

  const updateEnable = listeners["updateEnable"] || function () { };

  const isShowTopDept = getItem("deptLevelCode") == '001'

  function handleDelete({ row }) {
    deleteExamRule(row);
  }


  function handleDetails({ row }) {
    detailsExamRule(row);
  }
  const Deal = ({ props: { vo } }) => {
    let dealConf = [
      ["icon-message", "详情", () => handleDetails(vo), ""],
    ];

    const preYearFlag = new Date(moment().format("YYYY")).getTime() >
    new Date(vo.row.effectYear).getTime()
    if (preYearFlag) {
      dealConf.push(["icon-edit-disable", "编辑", () => { }, "examRule:update"]);
    } else {
      dealConf.push(["icon-edit", "编辑", () => handleUpdate(vo.row), "examRule:update"]);
    }
    if (vo.row.canDelete == 1) {
      dealConf.push(["icon-delete", "删除", () => handleDelete(vo), "examRule:delete"]);
    } else {
      dealConf.push(["icon-delete-disable", "删除", () => { return; }, "examRule:delete"])
    }
    if (vo.row.isEnable == 1) {
      dealConf.push(preYearFlag ?
        ["icon-unable-disabled", "停用", () => { return; }, "examRule:enable"]
        : ["icon-unable", "停用", () => updateEnable(vo.row), "examRule:enable"]);
    } else {
      dealConf.push(preYearFlag ? ["iconfont icqiyong_nor iconfont-adapt-disabled", "启用", () => { return; }, "examRule:enable"]
        : ["iconfont icqiyong_sel iconfont-adapt", "启用", () => updateEnable(vo.row), "examRule:enable"]);
    }
    return (
      <div class="deal-group">
        {dealConf.map(item => (
          <el-tooltip
            class="item"
            effect="dark"
            content={item[1]}
            placement="top"
            v-permission={item[3]}
          >
            <i class={item[0]} onClick={item[2]}>
              {" "}
            </i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const ExamCredit = ({ props: { vo } }) => {
    let item = vo.row;
    return (
      <div style={{ margin: "10px 0" }}>
        {
          item.examDetails.map(item => {
            return (
              <div>
                {item.examName}，{item.examCredit};
              </div>
            )
          })
        }
      </div>
    );
  };

  let AccountTableConfig = [
    {
      label: "适用组织",
      prop: "deptName",
      minWidth: "150",
      showOverflowTooltip: true
    },
    // {
    //   label: "组织名称",
    //   prop: "deptName",
    //   minWidth: "120",
    //   showOverflowTooltip: true
    // },
    {
      label: "考核方式",
      prop: "examTypeName",
      minWidth: "60",
    },
    {
      label: "达标学时",
      minWidth: "200",
      render: vo => <ExamCredit vo={vo} />
    },
    {
      label: "生效年份",
      prop: "effectYear",
      minWidth: "60"
    },
    {
      label: "状态",
      prop: "isEnableStr",
      minWidth: "60"
    },
    {
      label: "创建时间",
      prop: "createDate",
      minWidth: "100",
      showOverflowTooltip: true
    },
    {
      label: "操作",
      width: "170",
      fixed: "right",
      render: vo => <Deal vo={vo} />
    }
  ];
  if (isShowTopDept) {
    AccountTableConfig.splice(1, 0, {
      label: "所属分院",
      prop: "topDeptName",
      minWidth: "60",
    })
  }
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
